<template>
  <div class="info-page">
    <div v-if="tourSettings && tourSettings.introduction_page_id" class="p-4">

      <PageContent 
        :pageId="tourSettings.introduction_page_id"
        :tourId="activeTour"
        :debug="true"
      />
    </div>

    <div v-else-if="loading" class="text-center py-8">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900 mx-auto"></div>
      <p class="mt-4">{{ $t('loading', 'Loading...') }}</p>
    </div>
    
    <div v-else class="text-center py-8">
      <p>{{ $t('info.no_content', 'No information available') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageContent from '../components/PageContent.vue'
import api from '../services/api'

export default {
  name: 'VueInfo',
  components: {
    PageContent
  },
  data() {
    return {
      loading: false,
      tourSettings: null
    }
  },
  computed: {
    ...mapGetters('tours', ['activeTour'])
  },
  async mounted() {
    // Track page view
    if (window._paq) {
      window._paq.push(['setCustomUrl', window.location.pathname])
      window._paq.push(['setDocumentTitle', 'Info'])
      window._paq.push(['trackPageView'])
    }

    // Load tour settings
    await this.loadTourSettings()
  },
  methods: {
    async loadTourSettings() {
      try {
        // Get active tour from localStorage or URL
        const activeTour = this.activeTour || localStorage.getItem('activeTour') || this.getActiveTourFromUrl()
        
        const response = await api.getTourSettings(activeTour)
        this.tourSettings = response.data
        
        console.log('Tour settings loaded:', this.tourSettings)
      } catch (error) {
        console.error('Error loading tour settings:', error)
      }
    },

    getActiveTourFromUrl() {
      // Extract tour ID from URL if present
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('tour')
    }
  }
}
</script>

<style scoped>
.info-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}
</style> 